import * as React from 'react';
import { Context } from './injectIntl';
import { invariantIntlContext } from '../utils';
export default function useIntl() {
    var intl = React.useContext(Context);
    invariantIntlContext(intl);
    return intl;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-intl/lib/src/components/useIntl.js
// module id = 170
// module chunks = 7